import React, { Component } from 'react';
import DataTables from './DataTables';
import { Navigate, NavLink } from 'react-router-dom';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';
import Accordian from './Handovers/Accordian';
import ImagePopUp from './Handovers/ImagePopUp';
import LZString from 'lz-string';

class ViewImages extends Component {
  
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    
    let stores = JSON.parse(localStorage.getItem('storeData'));
    stores.sort();
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      title: this.props.location.state.id ? this.props.location.state.id : '',
      store: this.props.location.state.store
        ? this.props.location.state.store
        : '',
      FromDate: this.props.location.state.fromDate
        ? this.props.location.state.fromDate
        : dateString,
      ToDate: this.props.location.state.toDate
        ? this.props.location.state.toDate
        : dateStringNow,
      checklistName: this.props.location.state.checklistName
        ? this.props.location.state.checklistName
        : '',
      checklistType: this.props.location.state.checklistType
        ? this.props.location.state.checklistType
        : '',
      submittedBy: this.props.location.state.submittedBy
        ? this.props.location.state.submittedBy
        : '',
      redirect: '',
      data: [],
      alert: '',
      incType: '',
      //storeValue: stores[0].storeId,
      storeValue: '',
      storeSelected: false,
      closure: '',
      stores,
      wareHouses,
      user: menu,
      pageAllowed: false,

      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,

      codeJson: [],
      submittedByCodeJson: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      empSubmit: false,
      imagePath: [],
      loading: false,

      isOpen: false,
      editing: false,
      dataImage: '',
    };
  }
  editRow = (data) => {
    // data.images.map((img) => {
    //   alert(img);
    // });
    this.setState({
      editing: true,
      dataImage: data,
    });
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    let imager = [];
    data.images.map((img) => {
      axios
        .get(
          process.env.REACT_APP_UPLOAD_DOWNLOAD +
            this.state.apiInterface +
            '/download?objectId=' +
            img,
          {
            headers: headers,
            responseType: 'blob',
          }
        )
        .then((response) => {
          //Create a Blob from the PDF Stream

          var re = /(?:\.([^.]+))?$/;

          var ext = re.exec(img)[1]; // "txt"
          const MimeTypesMap = {
            png: 'image/png',
            gif: 'image/gif',
            jpg: 'image/jpg',
            jpeg: 'image/jpeg',
            pdf: 'application/pdf',
            mp4: 'video/mp4',
            doc: 'application/msword',
            docx:
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ppt: 'application/vnd.ms-powerpoint',
            pptx: 'application/vnd.ms-powerpoint',
            xlsx:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          };

          const mimeType = MimeTypesMap[ext];

          const file = new Blob([response.data], { type: mimeType });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          if (mimeType === 'application/pdf') {
            window.open(fileURL, '_blank');
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            imager.push({ url: url, path: img });
            const link = document.createElement('a');
            link.href = url;
            //link.setAttribute('download', img); //or any other extension
            //document.body.appendChild(link);
            //link.click();
          }
          this.setState({
            imagePath: imager,
            isOpen: true,
          });
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    });
  };
  setEditing = (x) => {
    this.setState({
      editing: x,
    });
  };
  setIsOPen = (x) => {
    this.setState({
      isOpen: x,
    });
  };
  downloadImage = (path) => {
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };

    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          this.state.apiInterface +
          '/download?objectId=' +
          path,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        //Create a Blob from the PDF Stream

        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(path)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          gif: 'image/gif',
          jpg: 'image/jpg',
          jpeg: 'image/jpeg',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.ms-powerpoint',
          xlsx:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];

        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        if (mimeType === 'application/pdf') {
          window.open(fileURL, '_blank');
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', path); //or any other extension
          document.body.appendChild(link);
          link.click();
        }

        this.setState({
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };
  goBack = () => {
    this.setState({
      redirect: this.props.location.state.id ==='Diagnosis'? '/diagnosis': '/handovers',
    });
  };

  componentDidMount() {
    //alert(JSON.stringify(this.props.location.state.title.handoverId));
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Handover'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );

    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
        visible: true,
      });
      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 1000);
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }

    ApiGateWay.Get(
      this.state.apiInterface +
        '/fetchChecklistImages?handoverId=' +
        this.props.location.state.title.handoverId
    )
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        console.log(JSON.stringify(response));
        this.setState({
          submittedByCodeJson: response,
          visible: true,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  }
  render() {
    if (this.state.redirect) {
      return (
       
        <Navigate
        to={this.state.redirect}
        state={{
                store: this.state.store,
                FromDate: this.state.FromDate,
                ToDate: this.state.ToDate,
                checklistName: this.state.checklistName,
                checklistType: this.state.checklistType,
                submittedBy: this.state.submittedBy,
        }}
      />
      );
    }
    const {
      loading,
      modalOpen,
      pageAllowed,
      message,
      submittedByCodeJson,
      imagePath,
      isOpen,
      store,
      FromDate,
      ToDate,
      checklistName,
      checklistType,
      submittedBy,
    } = this.state;

    return (
      <>
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}
        {!pageAllowed ? (
          <MessageBoxForInvalidPage message={this.state.message} />
        ) : null}
        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <div className='row'>
                  <div className='row' style={{ marginLeft: '10px' }}>
                    {this.state.editing ? (
                      <ImagePopUp
                        editing={this.state.editing}
                        setEditing={this.setEditing}
                        setIsOPen={this.setIsOPen}
                        dataImage={this.state.dataImage}
                        downloadImage={this.downloadImage}
                        isOpen={isOpen}
                        imagePath={imagePath}
                      />
                    ) : (
                      ''
                    )}
                    <div className=''>
                      <button
                        type='button'
                        className='btn btn-secondary deca-btn-orange'
                        onClick={this.goBack}
                        style={{ cursor: 'pointer' }}
                      >
                        <i className='fa fa-arrow-left' aria-hidden='true'></i>
                      </button>
                    </div>
                    <table
                      className='table table-bordered table-striped mainGrid'
                      style={{
                        borderCollapse: 'separate',
                        width: '80%',
                        marginTop: '10px',
                      }}
                    >
                      <thead
                        style={{
                          background: '#3c8dbc',
                          color: '#fff',
                        }}
                      >
                        <tr>
                          <th>
                            <span>{" Question's"}</span>
                            <span style={{ marginLeft: '444px' }}>
                              {' Actions'}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {submittedByCodeJson.categoryInfos ? (
                          submittedByCodeJson.categoryInfos.map((user) => (
                            <tr
                              key={user.key}
                              className='table-bordered table-striped'
                            >
                              <Accordian
                                category={user.key}
                                subCategory={user.subCategoryInfos}
                                editRow={this.editRow}
                              />
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3}>No Checklist Data</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default ViewImages;
